module.exports = __webpack_public_path__ + "media/images/user/triangle-769216c6696ad73a4ccb596ae8ed8eaf.svg";